export const formatArea = (value) => {
  if (value === null || value === undefined || value === "") {
    return 0;
  }

  const num = Number(value);

  if (Number.isNaN(num)) {
    return 0;
  }

  return num % 1 === 0
    ? num.toString()
    : num.toLocaleString("id-ID", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
};
